const pageNameKey = "blueprintUnassignedWarningIgnoreButtonWrapper";

export const blueprintUnassignedWarningIgnoreButtonWrapperEn = {
  [pageNameKey]: {
    warningMessage: "Drag and Drop to replace missing data point",
    warningIconAltText: "Warning unassigned!",
    buttonIgnoreText: "Ignore",
  },
};

export const blueprintUnassignedWarningIgnoreButtonWrapperPtBr = {
  [pageNameKey]: {
    warningMessage: "Arraste e solte para substituir o ponto de dados ausente",
    warningIconAltText: "Aviso não atribuído!",
    buttonIgnoreText: "Ignorar",
  },
};

export const blueprintUnassignedWarningIgnoreButtonWrapperDe = {
  [pageNameKey]: {
    warningMessage: "Ziehen und ablegen, um fehlenden Datenpunkt zu ersetzen",
    warningIconAltText: "Warnung nicht zugeordnet!",
    buttonIgnoreText: "Ignorieren",
  },
};

export const blueprintUnassignedWarningIgnoreButtonWrapperZhHans = {
  [pageNameKey]: {
    warningMessage: "拖放以替换缺失的数据点",
    warningIconAltText: "警告未分配！",
    buttonIgnoreText: "忽略",
  },
};

export const blueprintUnassignedWarningIgnoreButtonWrapperIt = {
  [pageNameKey]: {
    warningMessage: "Trascina e rilascia per sostituire il punto dati mancante",
    warningIconAltText: "Attenzione, non assegnato!",
    buttonIgnoreText: "Ignora",
  },
};

export const blueprintUnassignedWarningIgnoreButtonWrapperEs = {
  [pageNameKey]: {
    warningMessage:
      "Arrastra y suelta para reemplazar el punto de datos faltante",
    warningIconAltText: "¡Advertencia sin asignar!",
    buttonIgnoreText: "Ignorar",
  },
};

export const blueprintUnassignedWarningIgnoreButtonWrapperNl = {
  [pageNameKey]: {
    buttonIgnoreText: "Negeren",
    warningIconAltText: "Waarschuwing niet toegewezen!",
    warningMessage:
      "Drag & Drop en zet neer om een ontbrekend gegevenspunt te vervangen",
  },
};

export const blueprintUnassignedWarningIgnoreButtonWrapperTr = {
  [pageNameKey]: {
    buttonIgnoreText: "Görmezden gelmek",
    warningIconAltText: "Uyarının ataması kaldırıldı!",
    warningMessage: "Eksik veri noktasını değiştirmek için Sürükle ve Bırak",
  },
};
